import {inject, Injectable, Injector} from '@angular/core';
import {ActivatedRouteSnapshot, PRIMARY_OUTLET, RouterStateSnapshot, TitleStrategy} from "@angular/router";
import {Title} from "@angular/platform-browser";
import {LayoutService} from "../../layout/service/layout.service";

/**
 * Сервис, который расширяет Angular `TitleStrategy` для обеспечения пользовательского механизма
 * управления заголовками для Angular приложения. Он использует название приложения в качестве
 * базового заголовка и динамически добавляет заголовки маршрутов на основе состояния роутера.
 *
 * Этот сервис внедряется на корневом уровне и улучшает стандартную обработку заголовков путем
 * интеграции с Angular Router и опционально изменяет другие сервисы на основе активных маршрутов.
 */
@Injectable({
  providedIn: 'root'
})
export class CustomTitleStrategy extends TitleStrategy {

  private readonly injector: Injector = inject(Injector)
  private readonly APP_NAME: string = 'Downloader'

  constructor(readonly title: Title) {
    super()
  }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const title = this.buildTitle(snapshot);
    if (title !== undefined) {
      this.title.setTitle(title);
    }
  }

  override buildTitle(snapshot: RouterStateSnapshot): string | undefined {
    let pageTitle: string = this.APP_NAME
    let route: ActivatedRouteSnapshot | undefined = snapshot.root;
    while (route !== undefined) {
      const titleForRoute = this.getResolvedTitleForRoute(route);
      if (titleForRoute && titleForRoute.length > 0) pageTitle = `${this.APP_NAME}|${titleForRoute}`;
      (this.injector.get(LayoutService) as any).pageName.set(titleForRoute || '')
      route = route.children.find((child) => child.outlet === PRIMARY_OUTLET);
    }
    return pageTitle;
  }
}
